export const GET_PAGES = "GET_PAGES";
export const GET_SINGLE_PAGE = "GET_SINGLE_PAGE";
export const CLEAR_SINGLE_PAGE = "CLEAR_SINGLE_PAGE";
